import { render, staticRenderFns } from "./SubalcanceRenderer.vue?vue&type=template&id=caf446be"
import script from "./SubalcanceRenderer.vue?vue&type=script&lang=js"
export * from "./SubalcanceRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports